import { Controller } from "@hotwired/stimulus"

// Floating flash message: dismissed by its close button, and auto-dismissed
// after `delay` when `autoDismiss` is enabled.
export default class extends Controller {
  static values = {
    delay: { type: Number, default: 3500 },
    autoDismiss: { type: Boolean, default: false },
  }

  connect() {
    if (this.autoDismissValue) {
      this.timeout = setTimeout(() => this.dismiss(), this.delayValue)
    }
  }

  disconnect() {
    clearTimeout(this.timeout)
    clearTimeout(this.fadeTimeout)
  }

  dismiss() {
    this.element.classList.add("flash-leaving")
    // 400 = Duration of the opacity transition for `.flash > *` in _flash.scss
    this.fadeTimeout = setTimeout(() => this.element.remove(), 400)
  }
}
